import router from '@/router'
import { getToken } from '@/utils/cookies'
const token = getToken()
router.beforeEach((to, from, next) => {
  if(token && token.length > 0) { next()}
  else {
    if(to.meta.requireAuth) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  }
})
